import type { Filesystem, OpenAPIV3xDocument } from '@gitbook/openapi-parser';
import { parseOpenAPI } from '@gitbook/openapi-parser';
import { createCache } from '@gitbook/util-suspense-cache';

/**
 * Cache to load and parse OpenAPI file.
 */
export const openapiFetcherCache = createCache<string, Filesystem<OpenAPIV3xDocument>>({
    getKey: (url) => url,
    getValue: async (url) => {
        const response = await fetch(url);
        const text = await response.text();
        const { filesystem } = await parseOpenAPI({
            value: text,
            rootURL: url,
        });
        return filesystem;
    },
});
